export default {
    abilities: 'Abilities',
    abilityOne: {
        title: 'Locate or obtain information',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to continue exercising to maintain your compression capacity.',
    },
    abilityTwo: {
        title: 'Integrate and interpret',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to strengthen your reading skills.',
    },
    abilityThree: {
        title: 'Reflect and assess',
        desc:
            'You are at a <strong> {0} </strong> level of reading, we invite you to develop and improve your reading skills.',
    },
    abilityLocalizar: {
        green: 'You are doing amazing! You are able to find the information you need even in the farthest corner of the world.',
        yellow: 'Follow the trail! Your ability to locate information is constantly evolving. Perseverance is the key.',
        red: 'Cheer up! Explore the details of the readings more carefully. Try to see the information from another perspective.'
    },
    abilityIntegrar: {
        green: 'You are a legend! In each text, you decipher the hidden secrets like a real Sherlock.',
        yellow: 'Keep exploring! Each reading brings you closer to becoming a master of reading between the lines.',
        red: 'Don\'t be discouraged! Although you face challenges, you are on the right path to unravel the mysteries hidden in the texts. Keep going with determination!'
    },
    abilityReflexionar: {
        green: 'You are at the top level! Your ability to think critically and apply outside knowledge is amazing.',
        yellow: 'Keep going, discerning reader! You improve your ability to value ideas beyond the text.',
        red: 'Don\'t be discouraged, meaning seeker! It has not been an easy path, but you have had some successes with your reflections. We recommend opening your mind to more possibilities.'
    },
    abilityLevels: ['initial', 'intermediate', 'advanced'],
    achievements: 'Achievements',
    accumulated_items: 'Accumulated rewards',
    subtitle_accumulated_items: 'Here you find the BeeCoins and XP obtained in your reading adventure.',
    answered_questions: 'Answered Questions',
    back_to_avatars: 'Back to avatars',
    back_to_skins: 'Back to skins',
    buy_this_avatar: 'Buy this avatar',
    buy_this_skin: 'Buy this skin',
    check_your_progress: 'Check your progress',
    correct_answers: 'Correct Answers',
    cumulative_xp: 'Accumulated experience',
    edit_avatar: 'Edit <b>avatar</b>',
    edit_my_avatar: 'Edit my avatar',
    edit_skin: 'Edit <b>Skin</b>',
    global_progress: 'Global progress',
    global_progress_rank: ['Last 7 days', 'Last 30 days', 'Last 90 days'],
    leave: 'Leave',
    level: 'Level',
    my_categories: 'My categories',
    my_skins: 'My skins',
    points: 'Points',
    purchase_avatar_desc:
        'This is a special avatar that you can acquire by purchasing it with your BeeCoins. Once you buy it, it will be available in <b>Special avatars</b>.',
    purchase_skin_desc:
        'This is a special skin that you can acquire by buying it with your BeeCoins. Once you buy it, it will be available in <b>Special skins</b>.',
    save_changes: 'Save changes',
    special_avatar: 'Special avatar',
    special_avatars: 'Special avatars',
    standard_avatars: 'Standard avatars',
    special_skin: 'Special skin',
    special_skins: 'Special skins',
    standard_skins: 'Standard skins',
    you_have: 'You have',
    your_collection: 'Your collection',
    your_favorite_books: 'Your favorite books',
    your_favorite_books_desc: 'Review the books you selected as must-see in your collection.',
    your_profile: 'Your profile',
    menu_edit_tooltip: 'Here you can modify your avatar, your skin and your favorite categories.',
    student_code: 'Your code',
    student_code_message: 'Code copied to the clipboard',
    understood: 'Understood',
}
